import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
import store from "@/store";
const {BASE_API} = extractAPIValues()

// 获取声网token
export function getToken (args, formdata) {
	let url = BASE_API + '/chatroom/account/get_agora_token'
	return axiosPostHandler(url, args, formdata)
}

// 创建频道
export function createChannel (args, formdata) {
	let url = BASE_API + '/chatroom/v3/channel/create'
	return axiosPostHandler(url, args, formdata)
}

// 判断频道组中是否包含某一种频道
export function checkChannelGroupExist (args) {
	let url = BASE_API + '/chatroom/v2/channel/check_type_exist'
	return axiosGetHandler(url, args)
}

// 获取频道信息
export function getChannelInfo (args) {
	let url = BASE_API + '/chatroom/channel/get_channel_info'
	return axiosGetHandler(url, args)
}

// 加入频道
export function enterChannel (args, formdata) {
	let url = BASE_API + '/chatroom/channel/enter_channel'
	return axiosPostHandler(url, args, formdata)
}

// 退出频道
export function exitChannel (args, formdata) {
	let url = BASE_API + '/chatroom/channel/exit_channel'
	return axiosPostHandler(url, args, formdata)
}

// 删除频道
export function delChannel (args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel/delete'
	return axiosPostHandler(url, args, formdata)
}

// 编辑频道信息
export function editChannel (args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel/edit'
	return axiosPostHandler(url, args, formdata)
}

// 踢出房间/频道 (老版本接口 已弃用)
export function kickOutUser (args, formdata) {
	let url = BASE_API + '/chatroom/channel/kick_out_user'
	return axiosPostHandler(url, args, formdata)
}

// 踢出房间
// /chatroom/v2/room/kick_out
export function kickOutFromRoom (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/kick_out'
	return axiosPostHandler(url, args, formdata)
}

// 批量踢出房间
export function batchKickOutFromRoom (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/kick_out/many'
	return axiosPostHandler(url, args, formdata)
}

// 踢出频道
export function kickOutFromChannel (args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel/kick_out'
	return axiosPostHandler(url, args, formdata)
}


// 静音用户/频道  (老版本接口 已弃用)
export function muteUserOrChannel (args, formdata) {
	let url = BASE_API + '/chatroom/channel/mute'
	return axiosPostHandler(url, args, formdata)
}

// 静音用户
export function muteUser (args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel/mute_user'
	return axiosPostHandler(url, args, formdata)
}

// 静音频道
export function muteChannel (args, formdata) {
	let url = BASE_API + '/chatroom/channel/mute_channel'
	return axiosPostHandler(url, args, formdata)
}

// 解除静音用户/频道 (老版本接口 已弃用)
export function cancelMuteUserOrChannel (args, formdata) {
	let url = BASE_API + '/chatroom/channel/cancel_mute'
	return axiosPostHandler(url, args, formdata)
}

// 解除静音用户
export function cancelMuteUser (args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel/unmute_user'
	return axiosPostHandler(url, args, formdata)
}

// 解除静音频道
export function cancelMuteChannel (args, formdata) {
	let url = BASE_API + '/chatroom/channel/cancel_mute_channel'
	return axiosPostHandler(url, args, formdata)
}

// 用户房间静音
export function muteUserRoom (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/mute'
  return axiosPostHandler(url, args, formdata)
}

// 用户耳机静音
export function muteUseEarphone (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/mute_earphone'
  return axiosPostHandler(url, args, formdata)
}

// 获取封禁列表
export function getRuleList (args) {
	let url = BASE_API + '/chatroom/channel/get_kick_out_rules'
	return axiosGetHandler(url, args)
}

// 清除封禁列表
export function clearRuleList (args) {
	let url = BASE_API + '/chatroom/channel/clear_rules'
	return axiosGetHandler(url, args)
}

// 上报用户麦克风/耳机状态, state:麦克风 0开1关，earphone_state：耳机 1开0关
export function reportUserVoiceState (args, formdata: {state: number, earphone_state: number}) {
	let url = BASE_API + '/chatroom/v2/channel/voice_state'
	return axiosPostHandler(url, args, formdata)
}

// 上报推送进入房间成功
export function reportShowInvitedDialog (args) {
	let url = BASE_API + '/chatroom/channel/report_pushed'
	return axiosGetHandler(url, args)
}

// 修改频道设置
export function setChannelSettings (args, formdata) {
	let url = BASE_API + '/chatroom/v2/settings/channel/edit'
	return axiosPostHandler(url, args, formdata)
}

// 获取频道设置
export function getChannelSettings (args) {
	let url = BASE_API + '/chatroom/settings/get_channel_settings'
	return axiosGetHandler(url, args)
}

// 编辑频道密码
export function editChannelPassword (args, formdata) {
	let url = BASE_API + '/chatroom/channel/edit_password'
	return axiosPostHandler(url, args, formdata)
}

// 获取频道邀请码列表
export function getInviteCodes (args) {
	let url = BASE_API + '/chatroom/v2/invite/code/list/page'
	return axiosGetHandler(url, args)
}

// 删除邀请码
export function delInviteCode (args, formdata) {
	let url = BASE_API + '/chatroom/v2/invite/code/delete'
	return axiosPostHandler(url, args, formdata)
}

// 获取黑名单
export function getBlackList (args) {
	let url = BASE_API + '/chatroom/v2/room/black'
	return axiosGetHandler(url, args)
}

// 添加黑名单
export function addRoomBlack (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/black/add'
	return axiosPostHandler(url, args, formdata)
}

// 批量添加黑名单
export function batchAddRoomBlack (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/black/many'
	return axiosPostHandler(url, args, formdata)
}

// 移除黑名单
export function removeRoomBlack (args, formdata) {
	let url = BASE_API + '/chatroom/v2/room/black/remove'
	return axiosPostHandler(url, args, formdata)
}

// 移动频道
export function moveChannel (args, formdata) {
	let url = BASE_API + '/chatroom/v3/channel/move_channel'
	return axiosPostHandler(url, args, formdata)
}

// 设置频道语音码率
export function editChannelRtcProfile (args, formdata) {
	let url = BASE_API + '/chatroom/v1/channel/edit_audio_bitrate'
	return axiosPostHandler(url, args, formdata)
}

// 复制频道
export function copyChannel (args, formdata) {
	let url = BASE_API + '/chatroom/v2/channel/copy'
	return axiosPostHandler(url, args, formdata)
}

// 获取置顶频道公告 
// channel_id
export function getChannelTopAnc(args) {
  let url = BASE_API + '/chatroom/v2/channel/basic'
  return axiosGetHandler(url, args)
}

//新建置顶公告
export function createChannelAnc(args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel/anc/new'
  return axiosPostHandler(url, args, formdata)
}

//删除频道公告
export function deleteChannelAnc(args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel/anc/delete'
  return axiosPostHandler(url, args, formdata)
}

//修改频道公告
export function updateChannelAnc(args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel/anc/update'
  return axiosPostHandler(url, args, formdata)
}


//历史频道公告
export function getChannelAncList(args) {
  let url = BASE_API + '/chatroom/v2/channel/anc/list'
  return axiosGetHandler(url, args)
}

//确认频道公告，不再显示
export function confirmChannelAnc(args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel/anc/unset_top_user'
  return axiosPostHandler(url, args, formdata)
} 

//根据id获取频道公告
export function getAncByID(args) {
  let url = BASE_API + '/chatroom/v2/channel/anc'
  return axiosGetHandler(url, args)
}

//发送channel_id表示此频道通知已读
export function readAnc(args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel/anc/read'
  return axiosPostHandler(url, args, formdata)
}

// 设置频道免打扰
export function setChannelMute(args, formdata) {
  let url = BASE_API + '/chatroom/v2/settings/user_room/dnds'
  return axiosPostHandler(url, args, formdata)
}

// 同步bgm伴奏状态
export function setBgmState(args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel/audio_share'
	formdata.ws_id = store.getters.ws_id
  return axiosPostHandler(url, args, formdata)
}

// 移动成员
/* 
	@param room_id
	@param channel_id
	@param to_user_ids
*/
export function moveMember(args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel/move_member'
  return axiosPostHandler(url, args, formdata)
}

// 邀请手机端
/* 
	@param msg
	@param msg_type
	@param invite_code
*/
export function inviteMobile(args, formdata) {
  let url = BASE_API + '/chatroom/v2/channel/invite_mobile'
  return axiosPostHandler(url, args, formdata)
}

// 获取创建频道线路配置
export function getChannelAvLineConfig(args) {
  let url = BASE_API + '/chatroom/v2/channel/api_list'
  return axiosGetHandler(url, args)
}

// 向某个用户申请加入房间
export function applyJoinRoom(args, formdata: {room_id: string, channel_id: string | undefined, to_user_id: number}) {
  let url = BASE_API + '/chatroom/v2/apply_join'
  return axiosPostHandler(url, args, formdata)
}

// 批量创建频道
export function batchCreateChannels(args, formdata){
  const url = BASE_API + '/chatroom/v2/channel/create/batch'
  return axiosPostHandler(url, args, formdata)
}

// 获取用户房间邀请码列表
export function getUserInviteCodes(args) {
  const url = BASE_API + '/chatroom/v2/invite/user/code'
  return axiosGetHandler(url, args)
}

// 针对特定用户的语音包静音
export function setUserLaughterMute(args, formdata) {
  const url = BASE_API + '/chatroom/v2/msg/voice_pack/black/update'
  return axiosPostHandler(url, args, formdata)	
}

// 批量修改频道设置
export function batchSetChannelConfig(args, formdata) {
  const url = BASE_API + '/chatroom/v2/settings/channel/batch/edit'
  return axiosPostHandler(url, args, formdata)
}

// 批量删除频道
export function batchDeleteChannel(args, formdata) {
  const url = BASE_API + '/chatroom/v2/channel/batch/delete'
  return axiosPostHandler(url, args, formdata)
}

// 更新频道中用户状态
export function updateMemberRecordState(args) {
  const url = BASE_API + '/chatroom/v2/record_state'
  return axiosGetHandler(url, args)
}

// 获取频道悬浮窗游戏信息
export function getChannelGamingInfo (args) {
	let url = BASE_API + '/chatroom/v2/account/chan_gaming_info'
	return axiosGetHandler(url, args)
}

// 获取资源频道列表
export function getResourceChannelList(args) {
  const url = BASE_API + '/chatroom/v2/room/guide/channels'
  return axiosGetHandler(url, args)
}

// findChannel 获取频道基本信息
export function findChannelBaseInfo(args, formdata) {
  const url = BASE_API + '/chatroom/v2/channel/info_by_ids'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 获取频道分页列表
 * @param {Object} formdata 请求参数
 * @param {string} formdata.room_id 房间ID
 * @param {string} formdata.anchor_channel_id 锚点频道ID
 * @param {number} formdata.before 获取锚点频道之前的数量
 * @param {number} formdata.after 获取锚点频道之后的数量
 * @param {Array<string>} formdata.fold_group_ids 折叠的分组ID列表
 */
export function getChannelListByPage(args, formdata) {
  const url = BASE_API + '/chatroom/v2/channel/page/list'
  return axiosPostHandler(url, args, formdata)
}
/**
 * 获取分组中频道分页列表
 * @param {Object} args 请求参数
 * @param {string} args.room_id 房间ID
 * @param {string} args.group_id 分组ID
 * @param {string} args.anchor_channel_id 锚点频道ID
 * @param {number} args.before 获取锚点频道之前的数量
 * @param {number} args.after 获取锚点频道之后的数量
 */
export function getChannelGroupListByPage(args) {
  const url = BASE_API + '/chatroom/v2/channel/page/group'
  return axiosGetHandler(url, args)
}


/**
 * 根据索引获取频道分页列表
 * @param {Object} args 请求参数
 * @param {string} args.room_id 房间ID
 * @param {string} args.start_index 开始索引
 * @param {string} args.end_index 结束索引
 * @param {Array<string>} formdata.fold_group_ids 折叠的分组ID列表
 */
export function getChannelListByIndex(formdata) {
  const url = BASE_API + '/chatroom/v2/channel/page/index'
  return axiosPostHandler(url, {}, formdata)
}

/**
 * 根据类型获取全量频道列表
 * @param args 请求参数
 * @param {string} args.room_id 房间ID
 * @param {number} args.limit 分页查询参数 传入0为全量
 * @param {string} args.anchor_channel_id 锚点频道ID 上次分页的最后一个频道ID
 * @param {Array<number>} args.include_channel_types 包含的频道类型列表
 * @param {boolean} args.is_password 是否返回密码频道
 * @param {boolean} args.is_private 是否返回私密频道
 * @param {string} args.keyword 搜索关键词
 */
export function getFullChannelList(formdata) {
  const url = BASE_API + '/chatroom/v2/channel/list/simple'
  return axiosPostHandler(url, {}, formdata)
}

/**
 * 移动频道位置
 * @param args 
 * @param formdata 
 * @returns 
 */
export function moveChannelRelative(args, formdata) {
  const url = BASE_API + '/chatroom/v3/channel/move_channel_by_id'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 订阅频道
 * @param {string} formdata.ws_id websocket连接ID
 * @param {Object.<string, Array<string>>} formdata.room_channels 房间频道订阅信息，key为room_id，value为该房间下需要订阅的channel_id数组
 */
export function subscribeChannel(args, formdata) {
  const url = BASE_API + '/chatroom/v2/channel/subscribe'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 上麦
 * @param args 
 * @param formdata 
 * @returns 
 */
export function addChannelHost(args, formdata) {
  const url = BASE_API + '/chatroom/v2/channel/host/add'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 下麦
 * @param args 
 * @param formdata 
 * @returns 
 */
export function removeChannelHost(args, formdata) {
  const url = BASE_API + '/chatroom/v2/channel/host/del'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 申请上麦
 * @param args 
 * @param formdata 
 * @returns 
 */
export function requestChannelHost(args, formdata) {
  const url = BASE_API + '/chatroom/v2/channel/apply_host/add'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 取消申请上麦
 * @param args 
 * @param formdata 
 * @returns 
 */
export function cancelChannelHost(args, formdata) {
  const url = BASE_API + '/chatroom/v2/channel/apply_host/del'
  return axiosPostHandler(url, args, formdata)
}

/**
 * 获取频道申请上麦列表
 * @param args 
 * @returns 
 */
export function getChannelApplyHostList(args) {
  const url = BASE_API + '/chatroom/v2/channel/apply_host'
  return axiosGetHandler(url, args)
}